// SocketService.js
import io from "socket.io-client";

class SocketService {
    static instance;
    socket = null;

    // Adiciona 'server' como um parâmetro
    initialize(token, server) {

        if (this.socket) {
            // Desconecta o socket existente antes de iniciar um novo
            this.socket.disconnect();
        }

        this.socket = io(server, { // Usa 'server' para estabelecer a conexão
            auth: { token },
        });
        this.socket.on('connect', () => console.log('Conectado ao socket: ' + server));
    } 

    // Método para desconectar explicitamente do socket
    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            console.log('Desconectado do socket.');
        }

        this.socket = null; // Limpa a referência ao socket para permitir uma reconexão limpa
    }

    getSocket() {  
        if (!this.socket) {
            console.error("Socket não inicializado - chame SocketService.initialize(token, server) primeiro.");
            return null;
        }
        return this.socket;
    }

    static getInstance() {
        if (!SocketService.instance) {
            SocketService.instance = new SocketService();
        }
        return SocketService.instance;
    }
}

export default SocketService.getInstance(); // Exporta a instância singleton
